<div class="d-flex column">
  <img src="assets/images/person.png" style="height: 60px; width: 60px; z-index: 1; margin-left: 20px" *ngIf="type === 'PERSON'">
  <img src="assets/images/logo_small.png" style="width: 60px; height: 60px; z-index: 1; margin-left: auto; margin-right: 20px" *ngIf="type === 'TECHINJECT'">
  <div class="box" [class.box-ti]="type === 'TECHINJECT'" [class.box-p]="type === 'PERSON'">
    <ng-content></ng-content>
  </div>
</div>
